import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usr-paymentdetails',
  templateUrl: './usr-paymentdetails.component.html',
  styleUrls: ['./usr-paymentdetails.component.css']
})
export class UsrPaymentdetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
